module.exports = __webpack_public_path__ + "img/calendar.140b4317.svg";